import { useState, useCallback, useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePractitionersFilters = () => {
  const [searchParams] = useSearchParams();
  const [sortBy, setSortBy] = useState("rating"); // Changed default to rating
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  
  // Initialize filters with showFreeSession and includeThirdPartyRating
  const [filters, setFilters] = useState({
    serviceCategories: searchParams.get("category") ? [searchParams.get("category")!] : ["all_types"],
    distance: "any_distance",
    date: undefined as Date | undefined,
    timeSlot: "any_time",
    sessionType: "all",
    showFreeSession: false,
    includeThirdPartyRating: true, // Default to true as specified
  });

  // Debounce search query
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Define available time slots - ensure no duplicates
  const timeSlots = [
    'any_time',
    'morning',
    'afternoon', 
    'evening'
  ];

  // Simplified single-select category change logic
  const handleCategoryChange = useCallback((categoryName: string) => {
    console.log("Category changed to:", categoryName);
    setFilters(prev => ({ 
      ...prev, 
      serviceCategories: [categoryName] 
    }));
  }, []);

  const isDateDisabled = useCallback((date: Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  }, []);

  return {
    filters,
    setFilters,
    sortBy,
    setSortBy,
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    timeSlots,
    handleCategoryChange,
    isDateDisabled
  };
};
